import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from './_services/alert.service';
import { LogService } from './_services/logmanager.service';
import { DataService } from './_services/datamanager.service';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './_services/authentication.service';
import { LoginControl } from './_services/logincontrol.service';
import { GlobalsService } from './_services/globals.service';
import { takeWhile } from 'rxjs/operators';

@Component({
    templateUrl: './welcome.component.html'
})

export class WelcomeComponent implements OnInit, OnDestroy {
    alive = true;

    secretaries = <any>[];
    secretariaName = '';
    returnUrl: string;
    navigationExtras = <any>{};
    returns: boolean;
    data: any;
    errorMessage: string;
    sec = '';
    localSec = '';
    mostrarDesplegable = false;

    constructor(
        private alertService: AlertService,
        private dataService: DataService,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private loginControl: LoginControl,
        private globalStorage: GlobalsService
    ) {
        this.returnUrl = this.globalStorage.getItem('returnUrl');
        this.globalStorage.removeItem('returnUrl');
        if (this.globalStorage.getItem('navigationExtras') === '') {
            this.navigationExtras = [];
        } else {
            this.navigationExtras = JSON.parse(this.globalStorage.getItem('navigationExtras'));
        }
        if (this.returnUrl !== '') {
            this.returns = true;
        }
    }

    ngOnInit() {
        this.sec = this.globalStorage.getItem('secretaria');
        this.getData();
    }

    ngOnDestroy() {
        this.alive = false;
    }

    getData(): void {
        const params = <any>{
            'accio': 'WsGetSecretaries'
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('WelcomeComponent', data);
                this.secretaries = data[0];
                /**
                 * Si no es rep cap secretaria, es rep 'sec'.
                 */
                if (this.sec === 'sec' || this.sec === '' || !this.sec) {
                    this.loginControl.setcheckedsecretaria(true);
                    this.mostrarDesplegable = true;
                } else {
                    this.getSecretariaByToken();
                }

                if (this.returns) {
                    this.alertService.warning('Cal seleccionar una secretaria abans d\'accedir a ' + this.returnUrl + '.');
                }
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }

    /**
     * Assigna el ID del usuari com a ID cercat. Utilitzat pels usuaris sense permís de cerca d'alumnes.
     */
    getUserID(): void {
        const params = <any>{
            'accio': 'WsGetOwnID'
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('WelcomeComponent', data);

                // Si no té permís per cercar alumnes, només pot mostrar el seu
                this.globalStorage.setItem('searchUser', data[0]);
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }

    /**
     * Carrega la secretaria rebuda per el token. Si el codi de Secretaria rebut no existeix,
     * el sistema redirigeix a la pàgina d'inici amb el selector de Secretaries.
     */
    getSecretariaByToken(): void {
        const params = <any> {
            'accio': 'WsGetSecretariaByToken',
            'params': <any> {
                'codiSecretaria': this.sec
            },
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('WelcomeComponent', 'Id secretaria: ' + data[0]);

                if (data[0]['id'] === '') {
                    const currentsec = this.globalStorage.getItem('secretaria');

                    if (currentsec != null && !isNaN(parseInt(currentsec, 10)) && parseInt(currentsec, 10)) {
                        this.sec = this.globalStorage.getItem('secretaria');
                        this.secretariaName = this.globalStorage.getItem('secretariaName');
                        this.localSec = this.sec;
                    } else {
                        this.errorMessage = 'No s\'ha pogut identificar la secretaria. Redirigint a la pàgina inicial.';
                        this.alertService.error('No s\'ha pogut identificar la secretaria. Redirigint a la pàgina inicial.');
                        this.globalStorage.removeItems(['secretaria', 'secretariaName']).then(
                            () => {
                                window.location.href = 'welcome';
                            }
                        );
                    }
                } else {
                    this.getSecretaria(data[0]['id']);
                }
                this.loginControl.setcheckedsecretaria(true);
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }

    /**
     * Obté les dades de la Secretaria indicada.
     * @param secID ID de la Secretaria. Si no es rep, s'utilitzarà el valor per defecte de la variable 'sec'.
     */
    getSecretaria(secID = ''): void {
        this.sec = secID !== '' ? secID : this.sec;
        LogService.log('WelcomeComponent', 'funcion getSecretaria' + this.sec);

        const params = <any>{
            'accio': 'WsHasPermis',
            'params': <any> {
                'secretaria_id': this.sec,
                'permission': 'cercar_alumnes'
            },
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('WelcomeComponent', data);

                /**
                 * Si l'usuari no té permís, li assignem com a ID d'alumne cercat, el seu propi.
                 */
                if (!data[0]) {
                    this.getUserID();
                }

                for (let i = 0; i < this.secretaries.length; i++) {
                    if (this.sec === this.secretaries[i].id) {
                        this.globalStorage.setItem('secretaria', this.sec);
                        this.globalStorage.setItem('secretariaName', this.secretaries[i].nom);
                        this.localSec = this.sec;
                        this.secretariaName = this.secretaries[i].nom;
                        break;
                    }
                }

                const currentuseri = this.globalStorage.getItem('currentUser');
                if (currentuseri) {
                    const currentuser = JSON.parse(currentuseri);
                    LogService.log('WelcomeComponent', 'Check token: ' + currentuser.token);

                    this.authenticationService.checkSession(currentuser.token).subscribe(
                        data2 => {
                            LogService.log('WelcomeComponent', 'AUTH OK');
                            LogService.log('WelcomeComponent', data2);
                        },
                        error => {
                            this.errorMessage = <any>error;
                            this.alertService.error(this.errorMessage);
                        });
                }
                /**
                 * Si és necessari, creem la convocatòria.
                 */
                this.setConvocatoria();
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }

    /**
     * Crea la convocatòria a l'alumne si no en té per la Secretaria indicada i en la convocatòria activa.
     * Si l'usuari no és alumne, no es crea la convocatòria.
     */
    setConvocatoria(): void {
        const params = <any>{
            'accio': 'WsSetPrimeraConvocatoria',
            'params': <any> {
                'secretaria_id': this.sec
            },
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('WelcomeComponent', 'WsSetPrimeraConvocatoria: ' + data[0]);
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }
}
